import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

// Bus events for workspace Lead Partner lifecycle. Ids + actor only — no PII.
// The audit mapper treats `actor` as the member who performed the action.

export const LeadPartnerCreatedPayloadSchema = z.object({
  leadPartnerId: z.uuid(),
  workspaceId: z.uuid(),
  actor: ActorSchema,
  name: z.string(),
  occurredAt: z.iso.datetime(),
});
export type LeadPartnerCreatedPayload = z.infer<typeof LeadPartnerCreatedPayloadSchema>;

export const LeadPartnerDeactivatedPayloadSchema = z.object({
  leadPartnerId: z.uuid(),
  workspaceId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type LeadPartnerDeactivatedPayload = z.infer<typeof LeadPartnerDeactivatedPayloadSchema>;

export const LeadPartnerReactivatedPayloadSchema = z.object({
  leadPartnerId: z.uuid(),
  workspaceId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type LeadPartnerReactivatedPayload = z.infer<typeof LeadPartnerReactivatedPayloadSchema>;

// Emitted when a partner links a freshly issued (member-owned) API key.
// `actorId` is the member who issued it; `apiKeyId` is the linked key.
export const LeadPartnerKeyIssuedPayloadSchema = z.object({
  leadPartnerId: z.uuid(),
  workspaceId: z.uuid(),
  actor: ActorSchema,
  apiKeyId: z.uuid(),
  occurredAt: z.iso.datetime(),
});
export type LeadPartnerKeyIssuedPayload = z.infer<typeof LeadPartnerKeyIssuedPayloadSchema>;
